import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { getExternalManagePaidUsersUrl } from '../../../urls/getExternalManagePaidUsersUrl';
import { getUsersSeatsUrl } from '../../../urls/getUsersSeatsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
const FreeUserDowngradedTooltip = ({
  children,
  isNewSeatingModel
}) => /*#__PURE__*/_jsx(UITooltip, {
  placement: "top",
  title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
    elements: {
      UILink
    },
    message: isNewSeatingModel ? 'routing-ui.routingRules.users.needsSeat_jsx' : 'routing-ui.routingRules.users.freeAssignment_jsx',
    options: {
      external: true,
      href: isNewSeatingModel ? getUsersSeatsUrl() : getExternalManagePaidUsersUrl()
    }
  }),
  children: children
});
FreeUserDowngradedTooltip.displayName = 'FreeUserDowngradedTooltip';
export default FreeUserDowngradedTooltip;